import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter signup
    console.log('Newsletter signup:', email);
  };

  const exploreLinks = [
    { text: 'Home', path: '#hero' },
    { text: 'Services', path: '/services' },
    { text: 'Case Studies', path: '/case-studies' },
  ];

  const contactLinks = [
    { text: '+91-8010989509', path: '/' },
    { text: 'contact@rogerops.com', path: '/' },
  ];

  // Solutions links arranged for two columns
  const solutionsLinks = [
    { text: 'Cloud Migrations', path: '/services/cloud-migration' },
    { text: 'DevOps Optimization', path: '/services/devops' },
    { text: 'FinOps Expertise', path: '/services/finops' },
    { text: 'DevSecOps', path: '/services/security' },
    { text: 'Disaster Recovery', path: '/services/disaster-recovery' },
    { text: 'kubernetes expertise', path: '/services/containers' },
    { text: 'Solution Architecting', path: '/services/architecting' },
    { text: 'AWS Discounts', path: '/services/aws-discounts' },
    { text: '24/7 Support', path: '/services/support' },
    { text: 'Infra Monitoring', path: '/services/monitoring' },
    { text: 'Platform Analysis', path: '/services/platform-analysis' },
    { text: 'MLOps & GPUs', path: '/services/mlops' },
    { text: 'CI/CD Pipelines', path: '/services/ci-cd' },
    { text: 'Data Pipelines', path: '/services/data-pipelines' },
  ];


  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
        </svg>
      ),
      url: 'https://www.linkedin.com/company/rogerops/ ',
    },
    {
      name: 'Twitter',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
        </svg>
      ),
      url: 'https://twitter.com',
    },
    {
      name: 'GitHub',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
        </svg>
      ),
      url: 'https://github.com',
    },
  ];

  return (
    <footer className="bg-black text-white pt-16 pb-8 text-center md:text-left">
      <div className="mx-auto px-4 ml-[4rem] mr-[4rem] sm:px-6 lg:px-8">
        <div className="flex sm:flex-col md:flex-row justify-between flex-wrap lg:gap-8 md:gap-6 gap-24 mb-12">
          {/* Logo and Description */}
          <div className=" flex flex-col items-center md:items-start">
            <div className="lg:col-span-2 max-w-[20rem]">
              <Link to="/" className="flex items-center justify-center md:justify-start mb-6">
                <img
                  src="/images/white.webp"
                  alt="RogerOps Logo"
                  className="h-20 w-auto object-contain"
                />
              </Link>
              <p className="text-gray-400 mb-8">
                Empowering businesses with cutting-edge cloud solutions and
                DevOps excellence. Transform your digital infrastructure with
                RogerOps.
              </p>
              <div className="flex space-x-4 justify-center md:justify-start">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="flex gap-24 flex-wrap justify-center">
            <div className="flex flex-col md:flex-row gap-24">
              {/* Explore Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Explore</h3>
                <ul className="space-y-3">
                  {exploreLinks.map((link) => (
                    <li key={link.text}>
                      {link.path.includes('#') ? (
                        <HashLink
                          smooth
                          to={link.path}
                          className="text-gray-400 hover:text-white transition-colors"
                        >
                          {link.text}
                        </HashLink>
                      ) : (
                        <Link
                          to={link.path}
                          className="text-gray-400 hover:text-white transition-colors"
                        >
                          {link.text}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                {/* Contact Links */}
                <h3 className="text-lg font-semibold mb-4">Get In Touch</h3>
                <ul className="space-y-3">
                  {contactLinks.map((link) => (
                    <li key={link.text}>
                      <Link
                        to={link.path}
                        className="text-gray-400 hover:text-white transition-colors"
                      >
                        {link.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Solutions section with centered title and two columns */}
            <div className="lg:col-span-1">
              <h3 className="text-lg font-semibold mb-4  pr-[0rem] ">
                Solutions
              </h3>
              <div className="flex flex-cols gap-4">
                <div>
                  <ul className="space-y-3">
                    {solutionsLinks.map((link) => (
                      <li key={link.text}>
                        <Link
                          to={link.path}
                          className="text-gray-400 hover:text-white transition-colors text-sm"
                        >
                          {link.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="border-t border-gray-800 pt-8 mt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-lg font-semibold mb-2">Stay Updated</h3>
              <p className="text-gray-400">
                Subscribe to our newsletter for the latest updates and insights.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="flex">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-2 w-0 md:px-4 py-2 bg-gray-800 text-white rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#3498db]"
                required
              />
              <button
                type="submit"
                className="bg-blue-500 hover:bg-[#3498db] text-white px-2 md:px-6 py-2 rounded-r-md transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} RogerOps. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
